import React, { useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import DashboardNavbar from './components/navbar/index';
import DashboardSidebar from './components/sidebar/index';
import {
	ChatDock,
	ChatPanelLayoutContext,
	useChatPanelState,
} from '../../components/chat';


const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 70;

const RootStyle = styled('div')({
	display: 'flex',
	height: '100vh',
	overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
	flexGrow: 1,
	// Lets the content column give up width to the assistant instead of
	// overflowing the row when a page holds a wide table.
	minWidth: 0,
	overflow: 'auto',
	paddingTop: APP_BAR_MOBILE + 24,
	paddingBottom: theme.spacing(1),
	backgroundColor: '#f5f5f5',
	[theme.breakpoints.up('lg')]: {
		paddingTop: APP_BAR_DESKTOP + 10,
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
	},
}));

const DashboardLayout = () => {
	const [open, setOpen] = useState(false);
	// Held at the layout level: the navbar shrinks by exactly the panel's width.
	const chat = useChatPanelState();

	const chatLayout = useMemo(
		() => ({ offsetWidth: chat.offsetWidth, isResizing: chat.isResizing }),
		[chat.offsetWidth, chat.isResizing]
	);

	return (
		<ChatPanelLayoutContext.Provider value={chatLayout}>
			<RootStyle>
				<DashboardNavbar
					onOpenSidebar={() => setOpen(true)}
					isChatAllowed={chat.isAllowed}
					isChatOpen={chat.isOpen}
					isChatResizing={chat.isResizing}
					chatWidth={chat.offsetWidth}
					onToggleChat={chat.toggle}
				/>
				<DashboardSidebar
					isOpenSidebar={open}
					onCloseSidebar={() => setOpen(false)}
				/>
				<MainStyle>
					<Outlet />
				</MainStyle>
				{chat.isAllowed ? (
					<ChatDock
						isOpen={chat.isOpen}
						width={chat.width}
						onClose={chat.close}
						onResize={chat.resize}
						onResizeStart={chat.startResize}
						onResizeEnd={chat.endResize}
					/>
				) : null}
			</RootStyle>
		</ChatPanelLayoutContext.Provider>
	);
};
export default DashboardLayout;
